"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("BasisUpload 文件上传组件")]), _c("ul", [_c("li", [_vm._v("该组件继承 Ant Design Vue 的 Upload 组件所有属性和事件。"), _c("a", {
    attrs: {
      href: "https://www.antdv.com/components/upload-cn/"
    }
  }, [_vm._v("https://www.antdv.com/components/upload-cn/")])]), _c("li", [_vm._v("已集成七牛云浏览器端上传和服务端上传")])]), _c("h2", [_vm._v("代码演示")]), _c("pre", {
    pre: true
  }, [_c("code", {
    pre: true,
    attrs: {
      "v-pre": "",
      class: "language-vue"
    }
  }, [_vm._v('<template>\n  <BasisUpload ref="upload" v-model="list" :default-file-list="defaultFileList" @change="onChange">\n    <!-- 可自定义上传按钮样式，使用默认插槽 -->\n    <a-button type="dashed">点击或拖拽文件上传<a-icon type="upload" /> </a-button>\n  </BasisUpload>\n</template>\n\n<script>\nexport default {\n  data() {\n    return {\n      defaultFileList: [\n  {\n    uid: 1, // 必填，没有时可以使用url，否则显示列表时报错\n    name: \'img.png\', // listType为text和picture时必填，否则显示列表时报错\n    url: \'https://qiniu-dev.wszn.top/920691/cm/1628770717016.png\' // 必填\n    // status: \'error\', // 状态有：uploading done error removed\n    // response: \'Server Error 500\' // 自定义的错误提示，status为error时显示\n  }\n      ],\n      list: [] // 通过v-model双向绑定已上传的文件列表\n    }\n  },\n  methods: {\n    // 根据实际业务需要获取相关数据\n    onChange({ fileList }) {\n      // 只使用status为done的数据\n      const arr = fileList.filter((item) => item.status === \'done\')\n      // 根据业务需要，如果使用到name和url，则使用以下方式获取\n      this.list = arr.map((item) => {\n  return { name: item.name, url: item.url }\n      })\n      // 根据业务需要，如果只使用到url，则使用以下方式获取\n      this.list = arr.map((item) => item.url)\n    }\n  }\n}\n</script>\n')])]), _c("h2", [_vm._v("API")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("参数")]), _c("th", [_vm._v("说明")]), _c("th", [_vm._v("类型")]), _c("th", [_vm._v("默认值")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("value")]), _c("td", [_vm._v("可通过 v-model 获取文件列表；和 change 事件二选一用于绑定数据即可")]), _c("td", [_vm._v("Array")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("[]")])])]), _c("tr", [_c("td", [_vm._v("platform")]), _c("td", [_vm._v("上传平台 qiniu 七牛云 oss 阿里云 OSS(未支持)")]), _c("td", [_vm._v("string")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("qiniu")])])]), _c("tr", [_c("td", [_vm._v("mode")]), _c("td", [_vm._v("上传方式 client 浏览器端上传（从性能角度出发，优先使用 client） ，server 服务端上传")]), _c("td", [_vm._v("String")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("client")])])]), _c("tr", [_c("td", [_vm._v("accept")]), _c("td", [_vm._v("接受上传的文件类型, 详见 "), _c("a", {
    attrs: {
      href: "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept"
    }
  }, [_vm._v("input accept Attribute")])]), _c("td", [_vm._v("String")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("''")])])]), _c("tr", [_c("td", [_vm._v("action")]), _c("td", [_vm._v("上传的地址 mode 为 server 时生效；mode 为 client 时通过后台接口返回 uploadUrl")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("string\\|(file) => Promise")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("/api/v1/qiniu/file/upload")])])]), _c("tr", [_c("td", [_vm._v("limit")]), _c("td", [_vm._v("限制上传的文件最大数量 0 表示不受限制，为 1 时直接替换上一个值")]), _c("td", [_vm._v("Number")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("0")])])]), _c("tr", [_c("td", [_vm._v("size")]), _c("td", [_vm._v("文件大小限制，单位 MB，0 表示不受限制")]), _c("td", [_vm._v("Number")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("0")])])]), _c("tr", [_c("td", [_vm._v("errMsg")]), _c("td", [_vm._v("上传错误时的错误提示,a-upload 默认提示“上传错误”")]), _c("td", [_vm._v("String")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("上传错误")])])]), _c("tr", [_c("td", [_vm._v("defaultFileList")]), _c("td", [_vm._v("默认已经上传的文件列表")]), _c("td", [_vm._v("object[]")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("[]")])])]), _c("tr", [_c("td", [_vm._v("listType")]), _c("td", [_vm._v("上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card")]), _c("td", [_vm._v("String")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("text")])])]), _c("tr", [_c("td", [_vm._v("multiple")]), _c("td", [_vm._v("是否支持多选文件，ie10+ 支持。开启后按住 ctrl 可选择多个文件。")]), _c("td", [_vm._v("Boolean")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("false")])])]), _c("tr", [_c("td", [_vm._v("autoUpload")]), _c("td", [_vm._v("是否自动上传")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("true")])]), _c("td")]), _c("tr", [_c("td", [_vm._v("hideEntry")]), _c("td", [_vm._v("隐藏上传按钮入口，一般配合 showUploadList:false 和 autoUpload:false 进行使用。使用场景：某个只需要上传功能，不需要显示文件列表的业务")]), _c("td", [_vm._v("Boolean")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("true")])])])])]), _c("blockquote", [_c("p", [_vm._v("可通过 "), _c("code", {
    pre: true
  }, [_vm._v("v-model")]), _vm._v(" 进行数据绑定，也可以使用 "), _c("code", {
    pre: true
  }, [_vm._v("change")]), _vm._v(" 事件进行数据同步，根据实际业务需求二选一即可。两者和 Ant Design Vue 的 Upload 组件的 "), _c("a", {
    attrs: {
      href: "https://www.antdv.com/components/upload-cn/#change"
    }
  }, [_vm._v("change")]), _vm._v(" 事件返回结果一致。")])]), _c("h2", [_vm._v("事件")]), _c("ol", [_c("li", [_vm._v("startUpload：使用手动上传时，通过在父组件调用 "), _c("code", {
    pre: true
  }, [_vm._v("this.$refs.upload.startUpload()")]), _vm._v(" 进行触发，返回 "), _c("code", {
    pre: true
  }, [_vm._v("Promise")]), _vm._v("。")])]), _c("h2", [_vm._v("更多属性和事件请查看"), _c("a", {
    attrs: {
      href: "https://www.antdv.com/components/upload-cn/"
    }
  }, [_vm._v("Upload 上传")])])])])]);
}];
render._withStripped = true;